// Helpers that bridge web behaviors to native (Capacitor) equivalents.
// All are safe on web — IS_NATIVE is false there and the web path runs.
import { IS_NATIVE } from "@/config/apiBase";

/**
 * Open an external URL (Stripe portal, social intents, maps, …).
 * Native: system in-app browser (SFSafariViewController / Custom Tabs) —
 * navigating the WebView itself away from the bundle would strand the user.
 * Web: same-tab or new-tab navigation, matching the previous behavior.
 */
export async function openExternal(url, { newTab = false } = {}) {
  if (IS_NATIVE) {
    const { Browser } = await import("@capacitor/browser");
    await Browser.open({ url });
    return;
  }
  if (newTab) window.open(url, "_blank", "noopener");
  else window.location.href = url;
}

/**
 * Share a link. Native: the OS share sheet via the Share plugin (more
 * reliable than navigator.share inside WKWebView). Web: Web Share API when
 * available; returns false when unsupported so callers can fall back to
 * their copy-link / social-button UI.
 */
export async function shareLink({ title, text, url }) {
  if (IS_NATIVE) {
    const { Share } = await import("@capacitor/share");
    await Share.share({ title, text, url, dialogTitle: title });
    return true;
  }
  if (navigator.share) {
    await navigator.share({ title, text, url });
    return true;
  }
  return false;
}
